// Copyright (c) 2021, Elicenciamento. All rights reserved.

import React from "react";
import { Box, CircularProgress } from "@mui/material";

import makeStyles from "@mui/styles/makeStyles";

const useStyles = makeStyles((theme) => ({
  fixed: {
    width: "100vw",
    height: "100vh",
    position: "fixed",
    background: "#fafafa",
    zIndex: 100,
  },
  loading: {
    color: theme.palette.background.orange,
  },
  ".MuiCircularProgress-colorPrimary": {
    color: theme.palette.background.orange,
  },
}));

const ApplicationLoading = () => {
  const classes = useStyles();
  return (
    <Box display="flex" justifyContent="center" className={classes.fixed}>
      <Box
        component="main"
        display="flex"
        flexDirection="column"
        justifyContent="center"
      >
        <CircularProgress classes={{ root: classes.loading }} />
      </Box>
    </Box>
  );
};

export default ApplicationLoading;
